<template>
  <v-container>
    <v-row class="justify-center">
      <v-col cols="12" sm="8" md="6">
        <v-card v-if="error">
          <v-card-title>Invite</v-card-title>
          <v-card-text>
            <v-alert type="warning" icon="mdi-alert-circle-outline">
              {{ error }}
            </v-alert>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn @click="$emit('decline')">Go back</v-btn>
          </v-card-actions>
        </v-card>

        <v-card v-else-if="invite">
          <v-card-title>
            {{ invite.type === 'family' ? 'Family Invite' : 'Recipe Shared' }}
          </v-card-title>
          <v-card-text>
            <div v-if="invite.type === 'family'">
              <p>
                <strong>{{ fromName }}</strong> wants to share recipes with you.
              </p>
              <p class="text-body-medium mt-2">
                By accepting, you will both see all of each other's recipes,
                including any new ones added in the future.
              </p>
            </div>
            <div v-else>
              <p>
                <strong>{{ fromName }}</strong> wants to share a recipe with
                you.
              </p>
              <p v-if="recipeTitle" class="text-body-medium mt-2">
                Recipe: <strong>{{ recipeTitle }}</strong>
              </p>
              <p class="text-body-medium mt-2">
                The recipe will appear in your recipe list.
              </p>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn variant="text" @click="$emit('decline')">Decline</v-btn>
            <v-btn
              color="primary"
              variant="flat"
              :loading="loading"
              @click="$emit('accept')"
            >
              Accept
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
  import { computed, defineComponent, type PropType } from 'vue';
  import type { Invite } from '@/service/invite/types';
  import type { Profile } from '@/service/profile/types';

  export default defineComponent({
    name: 'InviteView',
    props: {
      invite: {
        type: Object as PropType<Invite>,
        default: undefined,
      },
      fromProfile: {
        type: Object as PropType<Profile>,
        default: undefined,
      },
      recipeTitle: {
        type: String,
        default: undefined,
      },
      loading: {
        type: Boolean,
        default: false,
      },
      error: {
        type: String,
        default: undefined,
      },
    },
    emits: ['accept', 'decline'],
    setup(props) {
      const fromName = computed(
        () => props.fromProfile?.displayName || 'Someone',
      );
      return { fromName };
    },
  });
</script>
